// pt-BR strings for the Plan 7 'territorio' namespace (t('territorio.…')), kept apart so each screen's strings live in one file.
export const territorioPt = {
  title: 'Território',
  module: 'módulo Território',
  tablist: 'Território',
  tabs: { superficiarios: 'Superficiários', sobreposicao: 'Sobreposição', oportunidades: 'Oportunidades' },
  loading: 'Carregando os imóveis sobre a carteira…',
  failed: 'Não foi possível carregar os superficiários agora. Tente de novo em alguns minutos.',
  lockedTitle: 'Superficiários: disponível com o módulo Superficiários',
  lockedBody:
    'Com o módulo Superficiários você vê cada imóvel certificado (SIGEF) — e, com o Ambiental, declarado no CAR — sobre os seus processos, cadastra quem é o superficiário e o acordo com cada um, e o fim de cada acordo vira prazo, com aviso 90 e 30 dias antes.',
  lockedCta: 'Ver planos',
  kpis: {
    parcels: 'Imóveis sobre a carteira',
    parcelsSub: 'SIGEF + CAR, sobre os seus processos',
    parcelsSubSigef: 'SIGEF, sobre os seus processos',
    withOwner: 'Com superficiário',
    withOwnerSub: 'cadastrados por você',
    active: 'Acordos vigentes',
    activeSub: '{{amount}} por mês',
    ending: 'Vencendo em 90 dias',
    endingSub: 'viram prazo em Atividades',
  },
  filters: {
    label: 'Filtrar por acordo',
    all: 'Todos',
    none: 'Sem acordo',
    active: 'Acordo vigente',
    ending: 'Vencendo',
  },
  processFilter: 'Filtrar por processo',
  allProcesses: 'Todos os processos',
  add: '+ Cadastrar superficiário',
  private: 'O cadastro de superficiários é visível só para a sua conta.',
  carMissing: 'Os imóveis do CAR aparecem com o módulo Ambiental (ou quando o SFB voltar a responder).',
  empty: 'Nenhum imóvel com esses filtros.',
  columns: { property: 'Imóvel', source: 'Fonte', process: 'Processo', overlap: 'Sobre a área', owner: 'Superficiário', agreement: 'Acordo', actions: 'Ações' },
  sources: { sigef: 'SIGEF', car: 'CAR' },
  unnamed: 'Imóvel sem denominação',
  noProperty: 'Sem imóvel vinculado',
  declared: '{{area}} declarados',
  matricula: 'matrícula {{matricula}}',
  register: 'Cadastrar',
  registerAnother: 'Cadastrar outro',
  edit: 'Editar',
  editOwner: 'Editar {{name}}',
  registerOn: 'Cadastrar superficiário de {{property}}',
  status: {
    none: 'sem acordo',
    active: '{{agreement}} vigente',
    ending: '{{agreement}} vence {{date}}',
    ended: '{{agreement}} encerrado',
    future: '{{agreement}} a partir de {{date}}',
  },
  until: 'até {{date}}',
  agreement: {
    none: 'Sem acordo',
    negotiating: 'Em negociação',
    access: 'Autorização de ingresso (pesquisa)',
    easement: 'Servidão',
    lease: 'Arrendamento',
    purchase: 'Compra do imóvel',
    court: 'Acordo judicial',
  },
  period: {
    monthly: 'Mensal',
    yearly: 'Anual',
    once: 'Parcela única',
    royalty: 'Participação nos resultados',
  },
  amountPer: {
    monthly: '{{amount}}/mês',
    yearly: '{{amount}}/ano',
    once: '{{amount}} (parcela única)',
    royalty: '{{amount}} (participação nos resultados)',
  },
  form: {
    title: 'Superficiário',
    close: 'Fechar',
    about: '{{property}} · sobre {{process}} · visível só para a sua conta',
    aboutNone: 'Visível só para a sua conta',
    property: 'Imóvel',
    noProperty: 'Sem imóvel vinculado',
    process: 'Processo (sem imóvel vinculado)',
    noProcess: 'Nenhum',
    name: 'Nome do superficiário',
    namePlaceholder: 'nome ou razão social',
    document: 'CPF/CNPJ',
    phone: 'Telefone',
    email: 'E-mail',
    agreement: 'Tipo de acordo',
    amount: 'Valor (R$)',
    period: 'Periodicidade',
    noPeriod: '—',
    startsOn: 'Início',
    endsOn: 'Fim',
    contract: 'Contrato (PDF)',
    soon: 'em breve',
    notes: 'Observações',
    remind: 'lembrar do fim do acordo (D-90, D-30)',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    remove: 'Remover',
    nameShort: 'Digite o nome (ao menos 2 letras).',
    endBeforeStart: 'O fim do acordo é antes do início.',
    failed: 'Não foi possível salvar. Confira os campos e tente de novo.',
    removeFailed: 'Não foi possível remover agora. Tente de novo.',
  },
} as const;
